import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {Section} from "../components/grouping/Section";
import {Button, Col, FormControl, FormLabel} from "react-bootstrap";
import {useState} from "react";
import {useMembers} from "../api/memberapi";
import {useAuthenticationContext} from "../contexts/authenticationcontext";
import {PasswordControl} from "../components/controls/FormControls";

export function RegisterPage(props) {
    const [registerOrSucces, setRegisterOrSucces] = useState(false)
    return <BasePageLayout title={"Registreer pagina"}>
        <p>U kunt enkel registreren als u uw lidnummer hebt.</p>

        {registerOrSucces ? <SuccesView/> :
            <RegisterFormCheckMemberNumber onRegisterOrSuccesChange={setRegisterOrSucces}/>}
    </BasePageLayout>
}

function RegisterFormCheckMemberNumber(props) {
    const {onRegisterOrSuccesChange} = props;
    const {members} = useMembers();
    const [lidnummer, setLidnummer] = useState("");


    const existingMember = members?.find(m => m?.lidNr === lidnummer);


    return <> {members ? <Section>
        <FormLabel>Lidnummer*</FormLabel>
        <FormControl onChange={e => setLidnummer(e.target.value)} placeholder={"Uw lidnummer"} type={"number"}/>
        {existingMember ? <RegisterForm existingMember={existingMember}

                                        onRegisterOrSuccesChange={onRegisterOrSuccesChange}/> : ""}

    </Section> : <Section>Aan het laden even geduld aub.</Section>
    }</>
}

function RegisterForm(props) {
    const {existingMember} = props;
    const [password, setPassword] = useState({
        pass1: "",
        pass2: "",
        email: existingMember?.email ? existingMember.email : ""
    })
    const {onRegisterOrSuccesChange} = props;

    const {signup} = useAuthenticationContext();

    async function handleSubmit(e) {
        const result = await signup(existingMember.voornaam, existingMember.sector, existingMember.lidNr, password.email, password.pass1);
        if (result) {
            onRegisterOrSuccesChange(true);
        }
    }

    console.log(password)
    return <Section>
        {existingMember ?
            <>

                <FormLabel>Email (Wordt gebruikt voor het herstellen van je wachtwoord. Dit is niet verplicht in te
                    vullen.)</FormLabel>
                <FormControl value={password.email}
                             onChange={e => setPassword({...password, email: e.target.value})}/>
                <PasswordControl title={'Herhaal wachtwoord*'} onChange={(e) => setPassword({...password, pass1: e.target.value})}
                                 tempObject={password} externalFieldName={"pass1"}/>
                <PasswordControl title={'Herhaal wachtwoord*'} onChange={(e) => setPassword({...password, pass2: e.target.value})}
                                 tempObject={password} externalFieldName={"pass2"}/>
                {
                    password.pass1 === password.pass2 && password.pass1 !== "" && password.pass2 !== "" ?
                        <Col xs={12} className={'text-end mt-2'}>
                            <Button onClick={e => handleSubmit(e)}>Registreer</Button>
                        </Col>
                        : "Wachtwoorden komen niet overeen!"
                }

            </>
            : "Lidnummer is niet gekend!"
        }
    </Section>
}

function SuccesView() {
    return <h4>U hebt zich succesvol geregistreerd en bent ingelogd op de website!</h4>
}